<template>
  <div style="height: 20px;" class="tagm" v-if="item.college!=null">
    <el-tooltip v-if="$utils.showflag(item.college.areaji)" class="item" effect="dark"
      :content="item.college.areaji+':'+item.college.area" placement="top-start">
      <el-tag class="mytag">{{item.college.areaji}}</el-tag>
    </el-tooltip>

    <el-tooltip v-if="item.college.byFlag!=null" class="item" effect="dark" :content="'保研率 : '+(item.college.byRate*100).toFixed(2)+'%'"
      placement="top-start">
      <el-tag class="mytag" type="danger">研</el-tag>
    </el-tooltip>
    <el-tooltip v-if="item.college.rk!=null" class="item" effect="dark" :content="'软科 : '+item.college.rk"
      placement="top-start">
      <el-tag class="mytag" type="success">软</el-tag>
    </el-tooltip>
    <el-tooltip v-if="item.college.xyh!=null" class="item" effect="dark" :content="'校友会 : '+item.college.xyh"
      placement="top-start">
      <el-tag class="mytag" type="warning">友</el-tag>
    </el-tooltip>



    <el-tooltip v-if="
    item.college.areaji!=null||
    item.college.byFlag!=null||
    item.college.rk!=null||
    item.college.sxwyq!=null||item.college.xyh!=null||
    item.college.yange!=null||item.college.yjxy!=null" class="item" placement="top-start" effect="dark">
      <div slot="content" style="color: #ffffff;line-height: 20px;" v-html="toBreak(item.college)"></div>
      <el-tag class="mytag" type="danger">i</el-tag>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: {

      item: {
        type: Object,
        default: {college:{}}
      }
    },
    data() {return{}},
    methods: {
      toBreak(college) {
        let str = '';
        if (college.areaji != null) {
          str += college.areaji + " : " + college.area + '<br/>'
        }
        if (college.byFlag != null) {
          str += "保研率 : " + (college.byRate*100).toFixed(2) + '%<br/>'
        }
        if (college.rk != null) {
          str += "软科 : " + college.rk + '<br/>'
        }
        if (college.xyh != null) {
          str += "校友会 : " + college.xyh + '<br/>'
        }
        if (college.yjxy != null) {
          str += "研究生院 : " + college.yjxy + '<br/>'
        }
        if (college.yange != null) {
          str += "历史沿革 : " + college.yange + '<br/>'
        }
        return str;
      },
    },
    mounted() {},
    created() {
    }
  };
</script>

<style scoped>
  .mytag {
    height: 18px;
    line-height: 16px;
    padding: 0 5px;
  }
  .tagm .item{
    display: inline-block;
    padding: 0 5px;
    border-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/icollege.vue